import { LiHTMLAttributes, ReactNode } from 'react'

interface IProfileDropdownItemProps extends LiHTMLAttributes<HTMLLIElement> {
  icon?: ReactNode
}

export const ProfileDropdownItem = (props: IProfileDropdownItemProps) => {
  const { icon, children } = props
  return (
    <li {...props} className='group flex cursor-pointer items-center'>
      <span className='mr-[18px] transition-opacity duration-150 group-hover:opacity-50'>
        <span className='block w-[16px] text-focus'>{icon}</span>
      </span>
      <span className='truncate text-[14px] text-focus transition-opacity duration-150 group-hover:opacity-50'>
        {children}
      </span>
    </li>
  )
}
